import axios from "axios";
import React, {useEffect, useRef, useState} from "react";
import {DataGrid, GridToolbar} from '@mui/x-data-grid';
import {Link} from 'react-router-dom';
import Swal from 'sweetalert2';
import AutoComplete from '@mui/material/Autocomplete';
import {baseUrl, ipAddress, userLocation, userName} from '../Univ.js'
function PackRoom() {
    const [packcats, setpackcats] = useState([]);
    const [insur, setInsur] = useState([]);
    const [PackRoom, setPackRoom] = useState([]);
    const [items, setItems] = useState([]);
    const inputRefs = useRef([]);
    const [rows, setRows] = useState([]);
    const [tabrows, setTabRows] = useState([]);
    const [subdata, setsubData] = useState([]);
    const [days, setDays] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [RoomData, setRoomData] = useState({
        "pack": '',
        "insur": '',
        "room": '',
        "roomamount": '',
        "days": '',
        "status": '',
        "addedby": '',
        "ip_add": ''
    });
    useEffect(() => {
        const fetchData = async () => {
            try {
                const [RoomResponse] = await Promise.all([
                    axios.get(`${baseUrl}room-type/`),
                ]);
                setItems(RoomResponse.data);
            } catch (error) {
                console.log(error);
            }
        };
        fetchData();
    }, []);
    const handleChange = (event) => {
        setRoomData({
            ...RoomData,
            [event.target.name]: event.target.value
        });
    }
    const handleKeyDown = (e, index) => {
        const newRows = [...rows];
        switch (e.keyCode) {
            // Handle Shift key
            case 16:
                e.preventDefault();
                if (index === rows.length - 1) {
                    newRows.push({id: '', room_no: '', days: '', amount: ''});
                }
                break;
            case 90:
                e.preventDefault();
                newRows.splice(index, 1);
                break;
            // Handle arrow up key
            case 38:
                e.preventDefault();
                if (newRows[index].selectedItem === 0) {
                    newRows[index].selectedItem = items.length - 1;
                } else {
                    newRows[index].selectedItem--;
                }
                setRows(newRows);
                break;
            // Handle arrow down key
            case 40:
                e.preventDefault();
                if (newRows[index].selectedItem === items.length - 1) {
                    newRows[index].selectedItem = 0;
                } else {
                    newRows[index].selectedItem++;
                }
                setRows(newRows);
                break;
            default:
                break;
        }
        setRows(newRows);
    };
    const handleDaysChange = (e, index) => {
        let newDays = e.target.value;
        // Ensure newDays is a number
        newDays = parseInt(newDays);
        // If newDays is less than or equal to 0, set it to 1
        newDays = newDays <= 0 ? 1 : newDays;
        const updatedRow = {...rows[index], days: newDays};
        const newRows = [...rows];
        newRows[index] = updatedRow;
        setRows(newRows);
        // Calculate the amount based on the selected room's amount
        const selectedRoomId = updatedRow.id;
        const selectedRoom = items.find(item => item.id === selectedRoomId);
        if (selectedRoom) {
            const updatedAmount = calculateAmount(newDays, selectedRoom.amount);
            updatedRow.amount = updatedAmount;
            newRows[index] = updatedRow;
            setRows(newRows);
        }
    };
    const calculateAmount = (days, roomAmount) => {
        // Perform the calculation here
        return days * roomAmount;
    };
    const handleSelect = (value, index) => {
        if (value === undefined || value === null) {
            const newRows = [...rows];
            newRows[index] = {...newRows[index], room: '', id: '', amount: ''};
            setRows(newRows);
        } else {
            const selectedItem = items.find(item => item.room === value);
            if (selectedItem) {
                const newRows = [...rows];
                newRows[index] = {...newRows[index], id: selectedItem.id, room: selectedItem.room};
                const updatedAmount = calculateAmount(newRows[index].days, selectedItem.amount);
                newRows[index].amount = updatedAmount;
                setRows(newRows);
            }
        }
    };
    const handleAddRow = () => {
        const newRows = [...rows, {id: '', room: '', days: '', amount: ''}];
        setRows(newRows);
    };
    useEffect(() => {
        inputRefs.current[inputRefs.current.length - 1]?.focus();
    }, [rows]);
    const handleDeleteRow = (index) => {
        const newRows = [...rows];
        newRows.splice(index, 1);
        setRows(newRows);
        inputRefs.current.splice(index, 1);
    };
    const formSubmit = () => {
        const _formData = new FormData();
        _formData.append('pack', RoomData.cat_id);
        _formData.append('insur', RoomData.insur_id);
        _formData.append('room', rows.map(row => row.id).join(','));
        _formData.append('roomamount', rows.map(row => row.amount).join(','));
        _formData.append('days', rows.map(row => row.days).join(','));
        _formData.append('addedby', userName);
        _formData.append('ip_add', ipAddress);
        _formData.append('location', userLocation);
        try {
            axios.post(baseUrl + 'create-pack-room/', _formData, {
                headers: {
                    'content-type': 'multiple/form-data'
                }
            })
                .then(function (response) {
                    if (response.status == 200 || response.status == 201) {
                        console.log(response.data)
                        Swal.fire({
                            title: 'Data has been updated',
                            icon: 'success',
                            timer: 2000,
                            showConfirmButton: false
                        });
                    }
                    setTimeout(() => {
                        window.location.href = ('/pack-room');
                    }, 2000);
                });
        } catch (error) {
            console.log(error);
        }
    };
    useEffect(() => {
        try {
            axios.get(baseUrl + 'create-pack/')
                .then(function (response) {
                    setpackcats(response.data);
                });
        } catch (error) {
            console.log(error);
        }
        try {
            axios.get(`${baseUrl}insur-cmpy/`)
                .then(response => {
                    setInsur(response.data);
                })
        } catch (error) {
            console.log(error);
        }
    }, []);
    useEffect(() => {
        fetchData();
    }, []);
    useEffect(() => {
        if (PackRoom.length > 0) {
            setTabRows(PackRoom);
        }
    }, [PackRoom]);
    function fetchData() {
        setIsLoading(true);
        axios.get(`${baseUrl}view-pack-room/`)
            .then(response => {
                setPackRoom(response.data);
                setIsLoading(false);
            })
            .catch(error => {
                console.log(error);
                setIsLoading(false);
            });
    }
    const handleDelete = (id) => {
        Swal.fire({
            title: 'Confirm',
            text: 'Are you sure you want to clear the fields for this entry?',
            icon: 'info',
            confirmButtonText: 'Continue',
            showCancelButton: true
        }).then((result) => {
            if (result.isConfirmed) {
                try {
                    // Construct the payload with the fields you want to clear
                    const payload = {
                        room: null,
                        roomamount: null,
                        days: null,
                        addedby: userName,
                        ip_add: ipAddress,
                    };
                    // Use Axios to send a PUT request to update the entry
                    axios.put(baseUrl + 'delete-pack-room/' + id, payload)
                        .then(function (response) {
                            Swal.fire('success', 'The fields have been cleared');
                            setTimeout(() => {
                                window.location.href = ('/pack-room');
                            }, 2000);
                        });
                } catch (error) {
                    Swal.fire('error', 'There was a problem updating the entry');
                }
            } else {
                Swal.fire('Cancelled', 'No changes have been made');
            }
        });
    };
    useEffect(() => {
        const fetchRoomData = async () => {
            try {
                // Flatten the Room IDs from all rows into a single array
                const allRoomIds = tabrows.flatMap(row => row.room.split(','));
                // Remove duplicates and empty strings, then map IDs to API requests
                const requests = [...new Set(allRoomIds)].filter(Boolean).map(id =>
                    axios.get(`${baseUrl}edit-room-type/${id}`)
                );
                const responses = await Promise.all(requests);
                const RoomDataArray = responses.map(response => response.data);
                setsubData(RoomDataArray);
            } catch (error) {
                console.error(error);
            }
        };
        fetchRoomData();
    }, [tabrows]);
    const columns = [
        {field: 'id', headerName: 'Id', width: 50},
        {
            field: 'pack_subcategory',
            headerName: 'Pack SubCategory',
            width: 200,
            renderCell: (params) => params.row.pack?.packsubcat || 'N/A',
        },
        {
            field: 'insurance_company',
            headerName: 'Insurance',
            width: 250,
            renderCell: (params) => params.row.insur?.company || 'N/A',
        },
        {
            field: 'room',
            headerName: 'Room Name',
            width: 250,
            renderCell: (params) => {
                if (!params.row.room) return 'N/A';
                // Split the comma-separated room IDs
                const roomIds = params.row.room.split(',').map((r) => r.trim());
                // Map IDs to actual names using subdata
                const roomNames = roomIds.map((id) => {
                    const roomObj = subdata.find((r) => r.id === parseInt(id));
                    return roomObj ? roomObj.room : id; // fallback to ID if not found
                });
                return (
                    <div style={{whiteSpace: 'normal', lineHeight: '1.5'}}>
                        {roomNames.map((name, index) => (
                            <div key={index}>{name}</div>
                        ))}
                    </div>
                );
            },
        },
        {
            field: 'roomamount',
            headerName: 'Room Amount',
            width: 150,
            renderCell: (params) => {
                if (!params.row.roomamount) return 'N/A';
                const roomAmounts = params.row.roomamount.split(',').map((a) => a.trim());
                return (
                    <div style={{whiteSpace: 'normal', lineHeight: '1.5'}}>
                        {roomAmounts.map((amt, index) => (
                            <div key={index}>{amt}</div>
                        ))}
                    </div>
                );
            },
        },
        {
            field: 'days',
            headerName: 'Days',
            width: 100,
            renderCell: (params) => {
                if (!params.row.days) return 'N/A';
                const daysList = params.row.days.split(',').map((d) => d.trim());
                return (
                    <div style={{whiteSpace: 'normal', lineHeight: '1.5'}}>
                        {daysList.map((day, index) => (
                            <div key={index}>{day}</div>
                        ))}
                    </div>
                );
            },
        },
        {field: 'addedby', headerName: 'Added By', width: 100},
        {
            field: 'edit',
            headerName: 'Edit',
            width: 100,
            renderCell: (params) => (
                <Link to={`/edit-packroom/${params.row.id}`} className="btn btn-warning">
                    Edit
                </Link>
            ),
        },
        {
            field: 'delete',
            headerName: 'Action',
            width: 120,
            renderCell: (params) => (
                <button
                    onClick={() => handleDelete(params.row.id)}
                    className="btn btn-danger btn-sm ms-1"
                >
                    <i className="fa-solid fa-trash-can"></i>
                </button>
            ),
        },
    ];
    const getRowHeight = () => {
        return 150;
    };
    return (
        <section className="container mt-4">
            <div className="row">

                <div className='col-md-9 col-12 mb-2'>
                    <div className='card'>
                        <h4 className='card-header'>Add Package Room</h4>
                        <div className='card-body'>
                            <form>
                                <div className="mb-3">
                                    <label htmlFor="cat_id" className="form-label">Package SubCategory</label>
                                    <select name="cat_id" value={RoomData.cat_id} onChange={handleChange}
                                            className="form-control">
                                        <option>Choose Package SubCategory</option>
                                        {packcats.map((category, index) => {
                                            return <option key={index} value={category.id}>{category.packsubcat}
                                            </option>
                                        })}
                                    </select>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="insur_id" className="form-label">Insurance</label>
                                    <select name="insur_id" value={RoomData.insur_id} onChange={handleChange}
                                            className="form-control">
                                        <option>Choose Insurance</option>
                                        {insur.map((insurer, index) => {
                                            return <option key={index} value={insurer.id}>
                                                {insurer.company}
                                            </option>
                                        })}
                                    </select>
                                </div>

                                <div className="table-responsive">
                                    <table className="erp-table-modern">
                                        <thead>
                                        <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                                            <th>ID</th>
                                            <th>Name</th>
                                            <th>Days</th>
                                            <th>Total</th>
                                            <th>Action</th>
                                        </tr>
                                        </thead>

                                        <tbody>
                                        {rows.map((row, index) => (
                                            <tr key={index}>
                                                <td>
                                                    <input
                                                        type="text"
                                                        className="ms-2 me-5 mt-4"
                                                        style={{width: 80}}
                                                        name="ltest_id"
                                                        value={row.id}
                                                        onChange={(e) => handleChange(e, index, 'id')}
                                                        readOnly
                                                    />
                                                </td>
                                                <td>
                                                    <AutoComplete
                                                        className="form-control mt-2"
                                                        value={row.room}
                                                        options={items.map(item => item.room)}
                                                        onChange={(event, value) => handleSelect(value, index)}
                                                        onInputChange={(event, newInputValue) => {
                                                            // Update input value
                                                            setRows(prevRows => {
                                                                const updatedRows = [...prevRows];
                                                                updatedRows[index].room = newInputValue;
                                                                return updatedRows;
                                                            });
                                                        }}
                                                        onKeyDown={e => handleKeyDown(e, index)}
                                                        renderInput={(params) => (
                                                            <div ref={params.InputProps.ref}
                                                            >
                                                                <input className="form-control"
                                                                       type="text" {...params.inputProps} focused
                                                                       autoFocus
                                                                       fullWidth
                                                                       style={{
                                                                           width: 300,
                                                                           background: "#F7EEFF",
                                                                       }}
                                                                />
                                                            </div>
                                                        )}
                                                        ref={(el) => inputRefs.current[index] = el}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="number"
                                                        className="ms-2 me-5"
                                                        value={row.days}
                                                        name="days"
                                                        style={{width: 100}}
                                                        onChange={(e) => handleDaysChange(e, index)}
                                                        min={1}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="number"
                                                        className="ms-2 me-5"
                                                        value={row.amount}
                                                        name="amount"
                                                        style={{width: 100}}
                                                    />
                                                </td>
                                                <td>
                                                    <button className="btn btn-danger" type="button"
                                                            onClick={() => handleDeleteRow(index)}>Delete
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </table>
                                    <button className="btn btn-success addmore mt-4" type="button"
                                            onClick={handleAddRow}>Add More
                                    </button>
                                </div>

                                <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                    <button type="button" onClick={formSubmit} className="btn btn-primary">Submit
                                    </button>
                                </div>

                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div style={{height: "100%", width: "100%"}}>
                {tabrows.length > 0 && (
                    <DataGrid className="mt-4"
                              sx={{
                                  boxShadow: 4,
                                  border: 4,
                                  borderColor: 'primary.light',
                                  '& .MuiDataGrid-cell:hover': {
                                      color: 'primary.main',
                                  },
                              }}
                              getRowHeight={getRowHeight}
                              pageSize={28}
                              rows={tabrows}
                              columns={columns}
                              room={{
                                  Toolbar: GridToolbar,
                              }}
                              autoHeight
                    />
                )}
            </div>

        </section>
    )
}
export default PackRoom;